/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { createSelector } from '@ngrx/store';
import { user } from './app.selectors';

export const userIsAdmin = createSelector(user, (user) => user?.admin);
export const userOpenIdProviderName = createSelector(user, (user) => user?.oidcProvider ?? null);
export const userEmail = createSelector(user, (user) => user?.email);
export const currentSessionIP = createSelector(user, (user) => user?.currentSessionIP);
